
















































import { Product } from '@/models'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class BlockProductModal extends Vue {
  @Prop({ required: true, type: Object }) product: Product

  hideModal() {
    this.$bvModal.hide('blockProductModal')
  }

  private blockSynchronizeEc() {
    const payload = { synchronizeEc: false }
    ApiClient.updateProduct(this.product.code, payload)
      .then(() => {
        this.$emit('productBlocked')
        this.product.synchronizeEc = false
        this.hideModal()
      })
      .catch((ex: Error) => {
        alert(`Error: ${ex.message}`)
      })
  }
}
